const searchData = {
  tasks: {
    'Client Code': {id: 'Client Code', content: 'Client Code'},
    'Client Account Number': {id: 'Client Account Number', content: 'Client Account Number'},
    'SSN': {id: 'SSN', content: 'SSN'},
    'Status': {id: 'Status', content: 'Status'},
    'Patient Name': {id: 'Patient Name', content: 'Patient Name'},
    'Phone Number': {id: 'Phone Number', content: 'Phone Number'},
    'City': {id: 'City', content: 'City'},
    'State': {id: 'State', content: 'State'},
    'Placement Date': {id: 'Placement Date', content: 'Placement Date'},
    'Total Balance': {id: 'Total Balance', content: 'Total Balance'},
  },
  columns: {
    'column-1': {
      id: 'column-1',
      title: 'Default Search',
      taskIds: [
        'Client Code',
        'SSN',
        'Status',
        'Patient Name',
        'Phone Number',
        'City',
        'State',
        'Placement Date',
        'Total Balance',
        'Client Account Number',
      ],
    },
    'column-2': {
      id: 'column-2',
      title: 'Added Queries',
      taskIds: [],
    },
  },
  // Facilitate reordering of the columns
  columnOrder: ['column-1', 'column-2'],
};

export default searchData;
